import { Done, Cancel } from "./Icons"

export default function Buttons({ inForm, update, color, cancelAction, inline }) {
    return (
        <div style={{
            display: "flex",
            gap: 5,
            flexDirection: inline ? 'row' : 'column',
            flexWrap: inline ? 'nowrap' : 'wrap'
        }}>
            {inForm ?
                <button
                    className={`${color}IconBtn`}
                    type={"button"}
                    onClick={update}
                >
                    <Done />
                </button> :
                <button
                    className={`${color}IconBtn`}
                    type={"submit"}
                >
                    <Done />
                </button>
            }

            <button
                className={`${color}IconBtn`}
                type="button"
                onClick={cancelAction}>
                <Cancel />
            </button>
        </div>
    )
}